import React, { useState, useEffect } from 'react';
import { adminService, AdminLog } from '../../services/adminService';
import { Activity, Clock, Shield, Search } from 'lucide-react';

const AdminAuditLog: React.FC = () => {
    const [logs, setLogs] = useState<AdminLog[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadLogs();
    }, []);

    const loadLogs = async () => {
        setLoading(true);
        const data = await adminService.getAuditLogs(100);
        setLogs(data);
        setLoading(false);
    };

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold text-gray-900 border-l-4 border-red-500 pl-3">Audit Logs</h1>
                <div className="text-xs text-gray-500 flex items-center gap-1">
                    <Shield size={12} /> Immutable Ledger
                </div>
            </div>

            <div className="bg-white rounded-lg shadow border border-gray-200 overflow-hidden">
                <div className="p-4 border-b bg-gray-50 flex items-center gap-2 text-sm text-gray-600">
                    <Activity size={16} />
                    Running Log (Last 100 Actions)
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full text-left font-mono text-sm">
                        <thead className="bg-gray-100 uppercase text-xs text-gray-500 font-bold border-b">
                            <tr>
                                <th className="px-4 py-3">Timestamp</th>
                                <th className="px-4 py-3">Admin</th>
                                <th className="px-4 py-3">Action</th>
                                <th className="px-4 py-3">Details</th>
                                <th className="px-4 py-3">Target ID</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {loading ? (
                                <tr><td colSpan={5} className="p-8 text-center text-gray-500">Retrieving tamper-proof logs...</td></tr>
                            ) : logs.length === 0 ? (
                                <tr><td colSpan={5} className="p-8 text-center text-gray-500">No logs found.</td></tr>
                            ) : (
                                logs.map(log => (
                                    <tr key={log.id} className="hover:bg-gray-50">
                                        <td className="px-4 py-3 text-gray-500 whitespace-nowrap">
                                            {log.timestamp?.seconds ? new Date(log.timestamp.seconds * 1000).toLocaleString() : 'Pending...'}
                                        </td>
                                        <td className="px-4 py-3 font-semibold text-indigo-700">
                                            {log.adminName}
                                        </td>
                                        <td className="px-4 py-3">
                                            <span className={`px-2 py-0.5 rounded text-xs font-bold ${log.action.includes('SUSPEND') ? 'bg-red-100 text-red-700' :
                                                    log.action.includes('GRANT') ? 'bg-green-100 text-green-700' :
                                                        'bg-blue-100 text-blue-700'
                                                }`}>
                                                {log.action}
                                            </span>
                                        </td>
                                        <td className="px-4 py-3 text-gray-800">
                                            {log.details}
                                        </td>
                                        <td className="px-4 py-3 text-gray-400 text-xs">
                                            {log.targetUserId || '-'}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AdminAuditLog;
